(() => {
  const indexOf = (gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const first = track.querySelector('[data-gallery-slide]');
    return first && first.clientWidth ? Math.round(Math.abs(track.scrollLeft) / first.clientWidth) : 0;
  };
  const sync = (gallery) => {
    const index = indexOf(gallery);
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    gallery.querySelectorAll('[data-gallery-index]').forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
    const count = gallery.querySelector('[data-gallery-count]');
    if (count) count.textContent = `${index + 1} / ${slides.length}`;
    const previous = gallery.querySelector('[data-gallery-direction="-1"]');
    const next = gallery.querySelector('[data-gallery-direction="1"]');
    if (previous) previous.disabled = index === 0;
    if (next) next.disabled = index >= slides.length - 1;
  };
  const show = (gallery, index) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = track.querySelectorAll('[data-gallery-slide]');
    const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
    const rtl = getComputedStyle(track).direction === 'rtl';
    track.scrollTo({ left: slides[safeIndex].clientWidth * safeIndex * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-gallery-index], [data-gallery-direction]');
    if (!button) return;
    const gallery = button.closest('[data-product-gallery]');
    if (!gallery) return;
    show(gallery, button.hasAttribute('data-gallery-index') ? Number(button.dataset.galleryIndex) : indexOf(gallery) + Number(button.dataset.galleryDirection));
  });
  document.addEventListener('keydown', (event) => {
    if (!event.target.matches('[data-gallery-track]') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    const gallery = event.target.closest('[data-product-gallery]');
    const rtl = getComputedStyle(event.target).direction === 'rtl';
    show(gallery, indexOf(gallery) + ((event.key === 'ArrowRight') !== rtl ? 1 : -1));
  });
  document.addEventListener('change', (event) => {
    if (event.target.id !== 'product-variant') return;
    const gallery = event.target.closest('.product-detail').querySelector('[data-product-gallery]');
    const imageId = event.target.selectedOptions[0].dataset.imageId;
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const index = slides.findIndex((slide) => slide.dataset.imageId === imageId);
    if (index >= 0) show(gallery, index);
  });
  document.addEventListener('scroll', (event) => {
    if (event.target.matches?.('[data-gallery-track]')) sync(event.target.closest('[data-product-gallery]'));
  }, true);
  const loadRelated = () => document.querySelectorAll('[data-related-products]').forEach((section) => {
    if (section.dataset.relatedReady) return;
    section.dataset.relatedReady = 'true';
    fetch(section.dataset.url).then((response) => {
      if (!response.ok) throw new Error('Recommendations unavailable');
      return response.text();
    }).then((html) => {
      const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-related-products]');
      if (replacement?.querySelector('[data-related-card]')) section.innerHTML = replacement.innerHTML;
    }).catch(() => {});
  });
  const initialize = () => {
    loadRelated();
    document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    if (gallery.dataset.galleryReady) return;
    gallery.dataset.galleryReady = 'true';
    sync(gallery);
  });
  };
  new MutationObserver(initialize).observe(document.body, { childList: true, subtree: true });
  initialize();
})();
